import * as React from "react";
import { X } from "lucide-react";

interface StyledModalProps {
    isOpen: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    children: React.ReactNode;
}

const StyledModal = ({ isOpen, setIsOpen, children }: StyledModalProps) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget && setIsOpen) {
            setIsOpen(false);
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Escape" && setIsOpen) {
            setIsOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={handleBackdropClick}
        >
            <div className="bg-background p-6 rounded-lg shadow-xl max-w-2xl w-full mx-4 relative">
                {setIsOpen && (
                    <button
                        onClick={() => setIsOpen(false)}
                        className="absolute top-2 right-2 p-1 text-text-weak hover:text-text transition-colors"
                    >
                        <X size={20} />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};

export default StyledModal;
